import { render, staticRenderFns } from "./user.vue?vue&type=template&id=2ccca390&"
import script from "./user.vue?vue&type=script&lang=js&"
export * from "./user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ccca390')) {
      api.createRecord('2ccca390', component.options)
    } else {
      api.reload('2ccca390', component.options)
    }
    module.hot.accept("./user.vue?vue&type=template&id=2ccca390&", function () {
      api.rerender('2ccca390', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/user-manage/user-accounts/user.vue"
export default component.exports